/**
 * "a" / "an" for a following word. Distinction names are data-driven
 * (Explorer, Kitchen CEO, Chef's Assistant…), so the article can't be
 * hardcoded in the copy.
 */
export function indefiniteArticle(word) {
  return /^[aeiou]/i.test((word || "").trim()) ? "an" : "a";
}

export default indefiniteArticle;
